import React, { useRef, useMemo } from "react";
import { Col, Form, Button } from "react-bootstrap";
import { editFolder } from "../../context/fetch/fetchTemplates";
import { useTemplatesValue } from "../../context/reducers/templatesContext";
import { useNavigate } from "react-router-dom";

const EditFolder = ({ setIndex, folderId }) => {
  const [state, dispatch] = useTemplatesValue();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  const handleOnSaveClick = () => {
    const folderName = nameRef.current.value;
    const list = state.folder.list;
    editFolder({ folderId, folderName }, list, dispatch, setIndex, navigate);
  };

  const handleOnCancelClick = () => {
    setIndex(0);
  };

  const folderNameMap = useMemo(() => {
    const allFolders = state.folder.list.flatMap((folder) => [folder, ...(folder.children || [])]);
    return new Map(allFolders.map((f) => [f.id, f.name]));
  }, [state.folder.list]);
  const name = folderNameMap.get(folderId) || "";

  return (
    <div className={"folder-editor "}>
      <div className={"text-end folder-btn-group"}>
        <Button onClick={handleOnCancelClick} className={"btn btn-dark"}>
          Cancel
        </Button>
      </div>
      <Col>
        <Form className={"my-3"} onSubmit={(e) => e.preventDefault()}>
          <Form.Group controlId="formBasicText" className={"position-relative"}>
            <Form.Control
              type="text"
              defaultValue={name}
              autoFocus
              className={"focus-effect cursor-pointer"}
              ref={nameRef}
              maxLength={30}
            />
            <span className={"focus-border"}></span>
          </Form.Group>
          <div className={"text-end"}>
            <Button type="submit" className={"btn-light"} onClick={handleOnSaveClick}>
              Save
            </Button>
          </div>
        </Form>
      </Col>
    </div>
  );
};

export default EditFolder;
